import { Mail } from "lucide-react";
import { ContactForm } from "@/components/home/ContactForm";

export const ContactSection = () => (
  <section id="contacto" className="py-16 sm:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
      <div className="md:col-span-5">
        <span className="inline-flex items-center gap-2 text-cyan-600 font-medium mb-4">
          <Mail className="h-5 w-5" /> Contacto
        </span>
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900">¿Tienes alguna duda?</h2>
        <p className="mt-4 text-slate-600">
          Escríbenos y te responderemos por correo lo antes posible. También puedes
          contactarnos directamente por WhatsApp con el botón verde.
        </p>
      </div>
      <ContactForm />
    </div>
  </section>
);
